"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validateNotNull = function (item, ignoreProps) {
    if (ignoreProps === void 0) { ignoreProps = []; }
    return !Object.keys(item).some(function (prop) { return item[prop] == null && !(ignoreProps === null || ignoreProps === void 0 ? void 0 : ignoreProps.includes(prop)); });
};
exports.default = validateNotNull;
